export class PosInfo {
    groups: IPosGroup[];
}

export interface IPosGroup {
    id: string;
    name: string;
}